import { queryOptions } from "@tanstack/react-query"
import { apiClient } from "@/shared/lib/apiClient"
import { unwrap } from "@/shared/utils/unwrap"

const HISTORY_DAYS = 90

// Floored to midnight local so the query key stays stable within a day (cache hits).
export function historyFrom(now: Date = new Date()): string {
  const d = new Date(now)
  d.setDate(d.getDate() - HISTORY_DAYS)
  d.setHours(0, 0, 0, 0)
  return d.toISOString()
}

export function sessionsQueryOptions(childId: string, from: string) {
  return queryOptions({
    queryKey: ["sessions", childId, { from }],
    queryFn: () =>
      unwrap(
        apiClient.GET("/api/children/{childId}/sleep-sessions", {
          params: { path: { childId }, query: { from } },
        }),
      ),
  })
}
